
import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { Footer } from "_components";
import { MainSettings } from "_types";
import { HomePageCMS } from "../types";
import Hero from "./Hero/index.vue";
import Latest from "./Latest/index.vue";
import NextEvent from "./NextEvent/index.vue";
import WhatsComing from './WhatsComing/index.vue';
import HeroAlternative from "./HeroAlternative/index.vue";
import EventTakeover from "./EventTakeover/index.vue";
import EventTakeoverMobButtons from "./EventTakeoverMobButtons/index.vue";

@Component({
  name: "HomeWrapper",
  components: {
    Hero,
    Latest,
    Footer,
    NextEvent,
    EventTakeover,
    EventTakeoverMobButtons,
    HeroAlternative,
    WhatsComing
  },
})
export default class HomeWrapper extends Vue {
  @Prop({ required: true }) data: HomePageCMS;
  @Prop({ required: true }) settings: MainSettings;
  @Ref() eventTakeoverRef: EventTakeover;
  @Ref() nextEventRef: NextEvent;
  @Ref() latestRef: Latest;

  get enableHeroAlternative() {
    return Boolean(this.data.hero_alternative.enable);
  }

  get enableEventTakeover() {
    return Boolean(this.data.event_takeover.enable);
  }

  get enableHero() {
    return Boolean(this.data.hero_section.enable);
  }

  get enableWhatsComing() {
    return Boolean(this.data.whats_coming.enable);
  }

  get enableNextEvent() {
    return Boolean(this.data.next_event_section.enable);
  }

  get enableLatest() {
    return Boolean(this.data.latest_section.enable);
  }

  get footerSettings() {
    return this.settings && this.settings.footer;
  }

  recalc() {
    if (this.nextEventRef) this.nextEventRef.recalc();
    // if (this.latestRef) this.latestRef.recalc();

    // this.$nextTick(() => {
    //   if (this.nextEventRef) this.nextEventRef.recalc();
    // });
  }

  calcAfterAnim() {
    // if (this.nextEventRef) this.nextEventRef.recalc();
  }
}
